<div class="container-fuid bg-white default-boxrounded">
    <div class="col-12 w-100">
        <h3 class="title col-9">
            <span translate="Sources.{{clientOnlineName}}"></span>
        </h3>
    </div>

    <div class="p-4 pt-0">
        <form [formGroup]="form">
            <div class="mb-3 row-cols-md-12">
                <label for="URL" class="form-label" translate="Settings.IntegrationsImportExportSection.URL"><app-info-button labelName="Settings.IntegrationsImportExportSection.URLTooltip"></app-info-button></label>
                <input type="text" id="URL" class="form-control" id="PinkwebUrl" [value]="pinkwebUrl" value="{{pinkwebUrl}}" [disabled]="!useClientOnline">
            </div>
            <div class="mb-3 col-12">
                <label for="Username" class="form-label" translate="Settings.IntegrationsImportExportSection.Username"><app-info-button labelName="Settings.IntegrationsImportExportSection.UsernameTooltip"></app-info-button></label>
                <input type="text" id="Username" class="form-control" id="PinkwebUsername" [value]="pinkwebUsername" [disabled]="!useClientOnline">
            </div>
            <div class="mb-3 col-12">
                <label for="Password" class="form-label" translate="Settings.IntegrationsImportExportSection.Password"><app-info-button labelName="Settings.IntegrationsImportExportSection.PasswordTooltip"></app-info-button></label>
                <input type="text" id="Password" class="form-control" id="PinkwebPassword" [value]="pinkwebPassword" [disabled]="!useClientOnline">
            </div>
        </form>

        <div class="col-12 mt-4 pb-2 d-table w-100">
            <span class="float-start"><button type="button" class="btn btn-sm btn-outline-primary" (click)="closeDialog()" translate>Button.Back</button></span>
            <span class="float-end"><button type="button" class="btn btn-sm btn-primary" (click)="save()" translate>Button.SaveChanges</button></span>
        </div>
    </div>
</div>